
import React from 'react';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from 'react-hook-form';

interface MeasurementFieldProps {
  form: UseFormReturn<any>;
  valueName: string;
  unitName: string;
  label: string;
  units: Array<{ value: string; label: string }>;
}

const MeasurementField: React.FC<MeasurementFieldProps> = ({ 
  form, 
  valueName, 
  unitName, 
  label, 
  units 
}) => {
  return (
    <div className="flex gap-2">
      <div className="flex-1">
        <FormField
          control={form.control}
          name={valueName}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{label}</FormLabel>
              <FormControl>
                <Input type="number" placeholder={`Enter ${label.toLowerCase()}`} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      <div className="w-20">
        <FormField
          control={form.control}
          name={unitName}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Unit</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Unit" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {units.map((unit) => (
                    <SelectItem key={unit.value} value={unit.value}>
                      {unit.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export default MeasurementField;
